import React, { useState } from "react";
import { useDrag } from "react-dnd";
import { SENTIMENT_STATUS } from "../../utils/sentimentStatus";

function SubmenuItem({
    text,
    gridData,
    disabled = false,
    sentimentStatus,
    overTimeDisabled,
    driversDisabled,
}) {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: "chart",
        item: { text, gridData },
        collect: (monitor) => ({
            isDragging: !!monitor.isDragging(),
        }),
    }));
    // State for tooltip visibility and position
    const [tooltip, setTooltip] = useState({ visible: false, x: 0, y: 0 });
    // Mouse enter and move event to show tooltip
    const handleMouseMove = (e) => {
        if (disabled) {
            setTooltip({
                visible: true,
                x: e.clientX,
                y: e.clientY,
            });
        }
    };

    // Mouse leave event to hide tooltip
    const handleMouseLeave = () => {
        setTooltip({ ...tooltip, visible: false });
    };

    let textTooltip =
        "Your data does not contain a date field for over time analysis.";
    if (overTimeDisabled) {
        textTooltip =
            "Your data does not contain a date field for over time analysis.";
    } else if ( driversDisabled) {
        textTooltip =
            "Your data does not contain a score field for Drivers analysis.";
    } else {
        switch (sentimentStatus) {
            case SENTIMENT_STATUS.BUILT_WITHOUT_SENTIMENT:
                textTooltip =
                    "Your data does not contain sentiment information.";
                break;
            case SENTIMENT_STATUS.BUILD_FAILED:
                textTooltip = "Sentiment analysis failed to build.";
                break;
            case SENTIMENT_STATUS.BUILDING:
                textTooltip = "Sentiment analysis is currently building.";
                break;
            case SENTIMENT_STATUS.READY:
                textTooltip = "Sentiment analysis is ready and available.";
                break;
            default:
                textTooltip = "";
        }
    }

    const itemClass = `submenu-item select-none droppable-element ${disabled ? "disabled" : ""}`;

    return (
        <>
            {tooltip.visible && (
                <div
                    className="submenu-tooltip"
                    style={{
                        position: "fixed",
                        left: `${tooltip.x + 10}px`,
                        top: `${tooltip.y + 10}px`,
                        background: "white",
                        border: "1px solid black",
                        padding: "5px",
                        color: "black",
                        opacity: "1",
                        zIndex: 1000,
                    }}
                >
                    {textTooltip
                        ? textTooltip
                        : "Your data does not contain a date field for over time analysis"}
                </div>
            )}
            <div
                className={itemClass}
                ref={!disabled ? drag : null}
                style={{ opacity: isDragging || disabled ? 0.5 : 1 }}
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseLeave}
                data-testid="dragableElement"
            >
                <h3>{text}</h3>
            </div>
        </>
    );
}

export default SubmenuItem;
